import { lazy } from 'react';
import DefaultSiteShell from 'src/components/site/shells/DefaultSiteShell';
import { SiteDefinition } from './SiteDefinition';

const ITDevFallback = lazy(() => import('src/pages/site/ITDevFallback'));

const defaultSite: SiteDefinition = {
    id: 'default',
    label: 'Site Not Configured',
    description: 'Fallback shell rendered when no specific site definition was resolved.',
    routes: [
        {
            key: 'it-dev-fallback',
            route: '/',
            component: ITDevFallback,
            exact: true,
        },
    ],
    shell: DefaultSiteShell,
};

export default defaultSite;
